import AkteCard from './container'
export { AkteCard }
export default AkteCard